import React, { useEffect, useState } from 'react';
import { BarChart, Bar, Rectangle, ReferenceLine, XAxis, YAxis, Tooltip, ResponsiveContainer, Area } from 'recharts';
import { useConfig } from '../../ConfigContext';
import dayjs, { Dayjs } from 'dayjs';
import ErrorBoundary from '../errorBoundary';
import { authedClient } from '../../api/authedClient';

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const level = payload[0].payload['mean_level']; // Access the level value
        // const dateTime = new Date(timestamp);
        // const formattedDate = dateTime.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        // const formattedTime = dateTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });


        if (typeof level === 'number' && !isNaN(level)) {
            return (
                <div
                    className="custom-tooltip"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        color: 'white',
                        padding: '8px',
                        borderRadius: '4px',
                        fontSize: "14px",
                    }}
                >
                    <p style={{ margin: 0 }}>{`Mean Level: ${level.toFixed(2)} m`}</p>
                </div>
            );
        }
        return null;
    }
    return null;
};

const DecadalMeanChart = () => {
    const { config } = useConfig();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [height, setHeight] = useState(250);


    useEffect(() => {
        const updateHeight = () => {
            const width = window.innerWidth;
            if (width < 640) setHeight(170);
            else if (width < 768) setHeight(200);
            else if (width < 1024) setHeight(230);
            else setHeight(250);
        };

        updateHeight();
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await authedClient.get('/api/analytics/historical-data/decadal-means');
                const result = response.data;
                setData(result);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const [isHighScale, setIsHighScale] = React.useState(
            window.devicePixelRatio >= 1.5
        );
        React.useEffect(() => {
            const handleScaleChange = () => {
                setIsHighScale(window.devicePixelRatio >= 1.5);
            };
    
            window.addEventListener("resize", handleScaleChange);
            return () => window.removeEventListener("resize", handleScaleChange);
        }, []);

    if (loading) return <p className='text-black'>Loading...</p>;
    if (error) return <p className='text-black'>Error: {error}</p>;

    let lastDisplayedYear = null;
    const ticks = [0.5, 1.0, 1.5, 2];

    return (
        // <div className="w-full" style={{ height }}>
        <div style={{ width: '100%', height: isHighScale ? "32vh" : "35vh" }}>
            <ResponsiveContainer width="100%" height="100%">
                {/* <ErrorBoundary> */}
                <BarChart
                    width="100%"
                    height="100%"
                    data={data}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 20,
                        bottom: 30,
                    }}
                >

                    {/* <CartesianGrid vertical={false} /> */}
                    <XAxis
                        dataKey="decade"
                        tick={{ fill: '#5E6664', fontSize: 12 }}
                        label={{
                            value: 'Years',
                            position: 'center',
                            dy: 15,
                            style: { textAnchor: 'middle', fill: '#5E6664', fontSize: 12 }
                        }}
                    />
                    <YAxis
                        domain={[0, 1.5]}
                        tickCount={3}
                        ticks={ticks}
                        tick={{ fill: '#5E6664', fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                        label={{
                            value: 'Meters (m)',
                            angle: -90,
                            position: 'insideLeft',
                            style: { textAnchor: 'middle', fill: '#5E6664', fontSize: 15 }
                        }}
                    />
                    {ticks.map(tick => (
                        <ReferenceLine key={tick} y={tick} stroke="#5E6664" strokeOpacity="30%" strokeDasharray="5 5" />
                    ))}
                    <Bar type="monotone" dataKey="mean_level" fill='#488DA3' activeBar={<Rectangle fill="#54F2F2" />} />
                    <Tooltip
                        cursor={{ fill: 'transparent' }}
                        content={<CustomTooltip />}
                    />
                </BarChart>
                {/* </ErrorBoundary> */}
            </ResponsiveContainer>
        </div>
    );
};

export default DecadalMeanChart;